var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPendingNumbers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "65px",
    height: "65px",
    viewBox: "0 0 65 65",
    enableBackground: "new 0 0 65 65",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    transform: "translate(0.166 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9",
    transform: "translate(-0.166 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    cx: 32.5,
    cy: 32.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#4B4B4B",
    strokeWidth: 2,
    cx: 32.5,
    cy: 32.5,
    r: 31.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-shield",
    fill: "#757575",
    d: "M49.379,33.292l-6.473-2.531c-0.4-0.154-0.846-0.154-1.246,0l-6.473,2.528 c-0.588,0.217-0.982,0.773-0.994,1.4c0,6.27,3.858,10.604,7.468,12.017c0.401,0.153,0.845,0.153,1.247,0 c4.689-2.126,7.637-6.868,7.466-12.015C50.363,34.064,49.968,33.508,49.379,33.292z M42.279,44.04V33.416l5.365,2.1 c-0.134,3.602-2.181,6.854-5.365,8.528V44.04z M26.997,32.44c3.971,0.003,7.192-3.214,7.196-7.186 c0.002-3.971-3.215-7.193-7.188-7.196c-3.971-0.003-7.193,3.214-7.196,7.186c0,0.002,0,0.005,0,0.008 c0,3.972,3.218,7.191,7.19,7.192c0,0,0,0,0.001,0L26.997,32.44z M32.391,34.688c0.012-0.135,0.033-0.269,0.062-0.398 c-0.14-0.006-0.275-0.045-0.421-0.045h-0.938c-2.599,1.197-5.592,1.197-8.191,0h-0.935c-4.169,0.001-7.549,3.381-7.551,7.55v2.337 c0,1.491,1.209,2.7,2.7,2.7l0,0h19.773c0.369-0.002,0.735-0.079,1.076-0.228c-3.578-2.91-5.634-7.299-5.574-11.912L32.391,34.688z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingNumbers);
export default __webpack_public_path__ + "static/media/pendingNumbers.bb85920a4a606b9a3a26c28430d4b311.svg";
export { ForwardRef as ReactComponent };